import { LinearProgress, Stack } from "@mui/material";
import { useMemo } from "react";
import { useGetPatientInvoicesQuery } from "src/api/services/invoicesApi";
import { skipToken } from "@reduxjs/toolkit/query";
import DataTable from "../DataTable";
import { useColumns } from "./utils/useColumns";
import { PatientProfile } from "src/api/types";

interface Props {
  patient: PatientProfile;
}

const PatientInvoices = ({ patient }: Props) => {
  const { data, isFetching } = useGetPatientInvoicesQuery(
    patient != null
      ? {
          patientId: patient.id,
        }
      : skipToken,
  );
  const columns = useColumns(patient.id);

  const { invoices } = useMemo(() => {
    if (data == null) return { invoices: [], count: 0 };

    return { invoices: data };
  }, [data]);

  return (
    <Stack>
      {isFetching ? <LinearProgress color="secondary" /> : null}
      <DataTable data={invoices} columns={columns} primaryKey="id" />
    </Stack>
  );
};

export default PatientInvoices;
